function ReviewHighlights({
  title,
  type,
  reviewsCount,
  positiveReviews,
  negativeReviews,
}) {

  const truncatedPositiveReviews = positiveReviews.slice(0, 5);
  const truncatedNegativeReviews = negativeReviews.slice(0, 5);

  return (
    <div className="review-category">
      <h6 className="review-category-title">{title}</h6>
      <p className="silent">
        {reviewsCount} reviews mention {type}
      </p>
      <div className="positive-reviews">
        <h6 className="review-category-subtitle">Positive reviews mention</h6>
        {truncatedPositiveReviews.map((review) => (
          <span className="tag positive">{review}</span>
        ))}
        {positiveReviews.length === 0 && (
          <span className="silent">No positive reviews</span>
        )}
      </div>
      <div className="negative-reviews">
        <h6 className="review-category-subtitle">Negative reviews mention</h6>
        {truncatedNegativeReviews.map((review) => (
          <span className="tag negative">{review}</span>
        ))}
        {negativeReviews.length === 0 && (
          <span className="silent">No negative reviews</span>
        )}
      </div>
    </div>
  );
}

export default ReviewHighlights;
